import {required} from "vuelidate/lib/validators";  
const languageresources = {
    data() { 
      return {   
        languageresourcesData: { 
          Resourcevalue: "" ,
          Resourceid:null,
          Langid:null
          }, 
          FormDataType:{
            Resourcevalue:{FieldName:"Resourcevalue",Field:"input",FieldTitle:this.$t('languageresources.AddEdit.Resourcename'),FieldType:"text"},
           } 
      }
    }, 
    validations:{ 
      FormData: {  
        Resourcevalue: { required}  
      } 
  },

  created(){

  } 
}
export default languageresources